import { render, staticRenderFns } from "./TermsAndConditions.vue?vue&type=template&id=a98f10e4&scoped=true"
var script = {}
import style0 from "./TermsAndConditions.vue?vue&type=style&index=0&id=a98f10e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98f10e4",
  null
  
)

export default component.exports